import { render } from "./UserIndex.vue?vue&type=template&id=3708b90e&scoped=true"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"

import "./UserIndex.vue?vue&type=style&index=0&id=3708b90e&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3708b90e"]])

export default __exports__